import React from 'react';
import { Link } from 'react-router-dom';

function NavItem() {
  return (
    <Link
      to='/'
      className='w-auto flex flex-col justify-center cursor-pointer py-2 px-3 font-bold text-center cursor-pointer flex-shrink'
    >
      FYN
    </Link>
  );
}

export default NavItem;
